import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import TopNavBar from "../../../Components/TopNavbar";
import LeftSideNav from "../../../Components/LeftSideNav";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import { Paper, TableContainer, Typography, Grid } from "@mui/material";
import Fonts from "../../../Config/Fonts";
import Colors from "../../../theme/Colors";
import { orderStatus } from "../../../Constants/AppConstants";

// Component for displaying each user detail item

// Component for displaying each user detail item
const DetailItem = ({ label, value }) => (
  <Grid
    item
    xs={12}
    sm={18}
    style={{
      display: "flex",
      alignItems: "center",
      padding: "8px 0",
      width: "30vw",
    }}
  >
    <Typography variant="subtitle1" style={labelInfoStyle}>
      <div>{label}</div>
    </Typography>
    <Typography
      style={{
        width: "100%",
        justifyContent: "start",
        display: "flex",
      }}
    >
      <div style={inputTextStyle}>
        :
        <p
          style={{
            fontSize: 16,
            fontWeight: "400",
            fontFamily: Fonts.Poppins,
            color: Colors.darkGray,
            marginLeft: "5px",
          }}
        >
          {value}
        </p>
      </div>
    </Typography>
  </Grid>
);

const OrderDetails = () => {
  const location = useLocation();
  const { orderData } = location?.state || {};
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    if (orderData) {
      setBreadcrumbs([
        { key: "1", href: "/orderList", text: "Orders" },
        {
          key: "2",
          href: `//orderList/:orderId`,
          text: `${orderData?.ship_user_first_name} Order`,
        },
      ]);
    }
  }, [orderData]);

  return (
    <div style={outerContainerStyle}>
      <LeftSideNav />
      <div style={innerContainerStyle}>
        <header style={headerStyle}>
          <TopNavBar leftSideText={'View Order Detail'}/>
          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </header>
        <TableContainer component={Paper} style={tableContainerStyle}>
          <h1 style={mainHeadingStyle}>
            Customer Details
          </h1>
          <hr />
          <Grid container style={gridStyle}>
            <Grid container spacing={4}>
              <DetailItem label="Name" value={orderData.order_id} />
              <DetailItem label="Address" value={orderData.order_id} />
            </Grid>
          </Grid>
        </TableContainer>
      </div>
    </div>
  );
};

const outerContainerStyle = {
  display: "grid",
  gridTemplateColumns: "20% 85%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
  backgroundColor: Colors.bgColor
};

const innerContainerStyle = {
  display: "grid",
  gridTemplateRows: "15% 80%",
  backgroundColor: Colors.bgColor,
};

const headerStyle = {
  width: "94%",
};

const tableContainerStyle = {
  width: "90%",
  height: "100%",
  border: "1px solid #ccc",
  borderRadius: "15px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  padding: "12px 0px 0px 20px",
  marginLeft: "25px",
  marginTop: "15px",
};

const gridStyle = {
  marginTop: "35px",
  marginLeft: '35px'
};

const mainHeadingStyle = {
  fontSize: 24,
  fontWeight: "500",
  fontFamily: Fonts.Poppins, // Ensure this matches the loaded font
  color: Colors.headingBlackColor,
  display: "flex",
  marginBottom: "10px",
};

const labelInfoStyle = {
  fontSize: 16,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  display: "flex",
  alignItems: "center",
  width: "80%",
};

const inputTextStyle = {
  fontSize: 16,
  fontWeight: "400",
  fontFamily: Fonts.Poppins,
  color: Colors.darkGray,
  display: "flex",
  alignItems: "center",
  width: "100%",
};

export default OrderDetails;
